import { OnInit, Component, Output, EventEmitter } from '@angular/core';
import { SearchService } from 'app/services/search.service';

@Component({
  selector: 'search-form',
  templateUrl: './search-form.component.html',
  standalone: false
})

export class SearchFormComponent implements OnInit {

  isStyleguide = false;
  expanded = false;
  @Output() expandedChange = new EventEmitter<boolean>();

  constructor(private searchService: SearchService) {}

  ngOnInit() {
    const pathname = window.location.pathname;
    const segments = pathname.split('/').filter(Boolean);
    const lastSegment = segments.pop() || '';
    this.isStyleguide = (lastSegment == 'styleguide');
  }

  toggleSearch() {
    if(!this.isStyleguide) {
      this.searchService.toggleSearch();
    }
  }

  onFocus() {
    this.expanded = true;
    this.expandedChange.emit(true);
  }

  onBlur() {
    this.expanded = false;
    this.expandedChange.emit(false);
  }
}
